import curd from '../curd'

const BASE_PATH = '/site/device'

export default curd(BASE_PATH)



// WEBPACK FOOTER //
// ./src/apis/modules/SiteDevice.js